export const downloadBlobFromDom = (blob: Blob, meta: any, defaultFilename: string = 'document', forceDefaultFilename: boolean = false): void => {
  let filename = defaultFilename;

  const contentDisposition = meta.response.headers.get('Content-Disposition');
  if (contentDisposition && !forceDefaultFilename) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match?.[1]) filename = match[1];
  }

  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);

  a.click();
  a.remove();

  URL.revokeObjectURL(url);
};